import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

const EXPENSE_TYPES = [
  "",
  "Transporte",
  "Mano de Obra",
  "Arrendamientos",
  "Asesoría",
  "Certificaciones",
  "Seguro",
  "Infraestructura",
  "Otros",
];

const FAKE_SUPPLIERS = [
  { id: "sup-001", name: "Distribuciones Agro S.A.", taxId: "900123456-1" },
  { id: "sup-002", name: "Insumos del Campo Ltda.", taxId: "900234567-2" },
  { id: "sup-003", name: "Servicios Agrícolas S.A.S.", taxId: "900345678-3" },
  { id: "sup-004", name: "Transporte Rural S.A.", taxId: "900456789-4" },
  { id: "sup-005", name: "Constructora Agro S.A.", taxId: "900567890-5" },
];

const ExpensesAndInvestmentForm = ({
  onSubmit,
  type = "create",
  initialValues = {},
  onCancel,
}) => {
  const defaultState = {
    date: "",
    expenseType: "",
    description: "",
    amount: "",
    supplierId: "",
    supplierData: { name: "", taxId: "", invoice: "" },
    createdAt: "",
  };

  const [form, setForm] = useState({ ...defaultState, ...initialValues });

  useEffect(() => {
    setForm({ ...defaultState, ...initialValues });

    if (initialValues.supplierId && !initialValues.supplierData?.name) {
      const found = FAKE_SUPPLIERS.find(
        (s) => s.id === initialValues.supplierId
      );
      if (found)
        setForm((f) => ({
          ...f,
          supplierData: {
            name: found.name,
            taxId: found.taxId,
            invoice: f.supplierData?.invoice || "",
          },
        }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const handleSupplierChange = (supplierId) => {
    const found = FAKE_SUPPLIERS.find((s) => s.id === supplierId);
    setForm({
      ...form,
      supplierId,
      supplierData: {
        name: found ? found.name : "",
        taxId: found ? found.taxId : "",
        invoice: "",
      },
    });
  };

  const onSubmitForm = () => {
    const payload = { ...form };
    if (!payload.createdAt) payload.createdAt = new Date().toISOString();
    // amount keep as string/decimal as provided
    onSubmit && onSubmit(payload);
  };

  return (
    <Grid rowGap="12px" columnGap="12px" padding="20px">
      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField
          name="date"
          label={strings.fields.date.label}
          placeholder="YYYY-MM-DD"
          value={form.date || ""}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
        />
        <SelectField
          name="expenseType"
          label={strings.fields.expenseType.label}
          value={form.expenseType || ""}
          onChange={(e) => setForm({ ...form, expenseType: e.target.value })}
        >
          {EXPENSE_TYPES.map((t) => (
            <option key={t} value={t}>
              {t || "--"}
            </option>
          ))}
        </SelectField>
      </Grid>

      <TextAreaField
        name="description"
        label={strings.fields.description.label}
        value={form.description || ""}
        onChange={(e) => setForm({ ...form, description: e.target.value })}
      />

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField
          name="amount"
          label={strings.fields.amount.label}
          placeholder="e.g. 1250.50"
          value={form.amount || ""}
          onChange={(e) => setForm({ ...form, amount: e.target.value })}
        />
        <SelectField
          name="supplierId"
          label={strings.fields.supplier.label}
          value={form.supplierId || ""}
          onChange={(e) => handleSupplierChange(e.target.value)}
        >
          <option value="">--</option>
          {FAKE_SUPPLIERS.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </SelectField>
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField
          name="supplierName"
          label={strings.fields.supplierName.label}
          value={form.supplierData?.name || ""}
          onChange={(e) =>
            setForm({
              ...form,
              supplierData: { ...form.supplierData, name: e.target.value },
            })
          }
        />
        <TextField
          name="supplierTaxId"
          label={strings.fields.supplierTaxId.label}
          value={form.supplierData?.taxId || ""}
          onChange={(e) =>
            setForm({
              ...form,
              supplierData: { ...form.supplierData, taxId: e.target.value },
            })
          }
        />
      </Grid>

      <TextField
        name="supplierInvoice"
        label={strings.fields.supplierInvoice.label}
        placeholder="factura.pdf"
        value={form.supplierData?.invoice || ""}
        onChange={(e) =>
          setForm({
            ...form,
            supplierData: { ...form.supplierData, invoice: e.target.value },
          })
        }
      />

      <Flex justifyContent="end">
        <Button
          children={strings.fields.buttons.reset}
          onClick={() => setForm(defaultState)}
        />
        <Button
          children={
            type === "create"
              ? strings.fields.buttons.create
              : strings.fields.buttons.save
          }
          onClick={onSubmitForm}
          variation="primary"
        />
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      date: { label: "Fecha" },
      expenseType: { label: "Tipo de gasto/inversión" },
      description: { label: "Descripción" },
      amount: { label: "Valor" },
      supplier: { label: "Proveedor" },
      supplierName: { label: "Proveedor - Nombre" },
      supplierTaxId: { label: "Proveedor - NIT" },
      supplierInvoice: { label: "Factura de compra (archivo)" },
      createdAt: { label: "Fecha de creación" },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
        cancel: "Cancelar",
      },
    },
    modal: {},
  },
});

export default ExpensesAndInvestmentForm;
